<cac-dialog-layout [title]="data ? 'تغییر دادن کاربر' : 'اضافه کردن کاربر جدید'" (onSubmit)="onSubmit($event)" cancelBtn="لغو" submitBtn="ذخیره" [permission]="!!data ? 'EditUser' : ''">
  <cac-form-builder [options]="userForm" class="mt-6 mb-8"></cac-form-builder>
  @if (data) {
  <cac-button (onClick)="onToggleChangePassword()" appearance="stroked" class="w-fit">{{changePasswordMode() ? 'عدم تغییر پسورد' : 'تغییر پسورد'}}</cac-button>
    @if(changePasswordMode()) {
        <cac-form-builder [options]="updatePasswordForm" class="mt-8"></cac-form-builder>
    }
  }
</cac-dialog-layout>